<template>
    <requisicoes
        :dataServicos="obterDataServicos()"
        rotaDetalhar="Gescon_Aprovadores_Requisicoes_Detalhar"
        rotaListagem="Gescon_Aprovadores_Requisicoes"
    ></requisicoes>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'
import Requisicoes from '../../contratos/requisicoes/Requisicoes'

export default {
    methods: {
        obterDataServicos() {
            return RequisicoesServicos
        }
    },

    components: {
        Requisicoes
    }
}
</script>
